export const CHECK_IDENTIFIER = {
  STATUS: {
    VERIFIED: 'verified',
    NOT_VERIFY: 'not_verify',
    NOT_EXIST: 'not_exist',
  }
}